// ---------------------------------------------------------------------------
// Country dial-code data with ISO-2 codes (used to render flag emoji)
// ---------------------------------------------------------------------------
const DIAL_CODE_DATA = [
	{ code: '+93', name: 'Afghanistan', iso: 'AF' },
	{ code: '+355', name: 'Albania', iso: 'AL' },
	{ code: '+213', name: 'Algeria', iso: 'DZ' },
	{ code: '+376', name: 'Andorra', iso: 'AD' },
	{ code: '+244', name: 'Angola', iso: 'AO' },
	{ code: '+54', name: 'Argentina', iso: 'AR' },
	{ code: '+374', name: 'Armenia', iso: 'AM' },
	{ code: '+61', name: 'Australia', iso: 'AU' },
	{ code: '+43', name: 'Austria', iso: 'AT' },
	{ code: '+994', name: 'Azerbaijan', iso: 'AZ' },
	{ code: '+973', name: 'Bahrain', iso: 'BH' },
	{ code: '+880', name: 'Bangladesh', iso: 'BD' },
	{ code: '+375', name: 'Belarus', iso: 'BY' },
	{ code: '+32', name: 'Belgium', iso: 'BE' },
	{ code: '+501', name: 'Belize', iso: 'BZ' },
	{ code: '+229', name: 'Benin', iso: 'BJ' },
	{ code: '+975', name: 'Bhutan', iso: 'BT' },
	{ code: '+591', name: 'Bolivia', iso: 'BO' },
	{ code: '+387', name: 'Bosnia and Herzegovina', iso: 'BA' },
	{ code: '+267', name: 'Botswana', iso: 'BW' },
	{ code: '+55', name: 'Brazil', iso: 'BR' },
	{ code: '+246', name: 'British Indian Ocean Territory', iso: 'IO' },
	{ code: '+673', name: 'Brunei', iso: 'BN' },
	{ code: '+359', name: 'Bulgaria', iso: 'BG' },
	{ code: '+226', name: 'Burkina Faso', iso: 'BF' },
	{ code: '+257', name: 'Burundi', iso: 'BI' },
	{ code: '+238', name: 'Cabo Verde', iso: 'CV' },
	{ code: '+855', name: 'Cambodia', iso: 'KH' },
	{ code: '+237', name: 'Cameroon', iso: 'CM' },
	{ code: '+345', name: 'Cayman Islands', iso: 'KY' },
	{ code: '+236', name: 'Central African Republic', iso: 'CF' },
	{ code: '+235', name: 'Chad', iso: 'TD' },
	{ code: '+56', name: 'Chile', iso: 'CL' },
	{ code: '+86', name: 'China', iso: 'CN' },
	{ code: '+57', name: 'Colombia', iso: 'CO' },
	{ code: '+269', name: 'Comoros', iso: 'KM' },
	{ code: '+243', name: 'Congo, Democratic Republic of the', iso: 'CD' },
	{ code: '+242', name: 'Congo, Republic of the', iso: 'CG' },
	{ code: '+506', name: 'Costa Rica', iso: 'CR' },
	{ code: '+225', name: "Cote d'Ivoire", iso: 'CI' },
	{ code: '+385', name: 'Croatia', iso: 'HR' },
	{ code: '+53', name: 'Cuba', iso: 'CU' },
	{ code: '+357', name: 'Cyprus', iso: 'CY' },
	{ code: '+420', name: 'Czech Republic', iso: 'CZ' },
	{ code: '+45', name: 'Denmark', iso: 'DK' },
	{ code: '+253', name: 'Djibouti', iso: 'DJ' },
	{ code: '+767', name: 'Dominica', iso: 'DM' },
	{ code: '+809', name: 'Dominican Republic', iso: 'DO' },
	{ code: '+593', name: 'Ecuador', iso: 'EC' },
	{ code: '+20', name: 'Egypt', iso: 'EG' },
	{ code: '+503', name: 'El Salvador', iso: 'SV' },
	{ code: '+240', name: 'Equatorial Guinea', iso: 'GQ' },
	{ code: '+372', name: 'Estonia', iso: 'EE' },
	{ code: '+268', name: 'Eswatini', iso: 'SZ' },
	{ code: '+251', name: 'Ethiopia', iso: 'ET' },
	{ code: '+679', name: 'Fiji', iso: 'FJ' },
	{ code: '+358', name: 'Finland', iso: 'FI' },
	{ code: '+33', name: 'France', iso: 'FR' },
	{ code: '+241', name: 'Gabon', iso: 'GA' },
	{ code: '+220', name: 'Gambia', iso: 'GM' },
	{ code: '+995', name: 'Georgia', iso: 'GE' },
	{ code: '+49', name: 'Germany', iso: 'DE' },
	{ code: '+233', name: 'Ghana', iso: 'GH' },
	{ code: '+30', name: 'Greece', iso: 'GR' },
	{ code: '+299', name: 'Greenland', iso: 'GL' },
	{ code: '+473', name: 'Grenada', iso: 'GD' },
	{ code: '+502', name: 'Guatemala', iso: 'GT' },
	{ code: '+224', name: 'Guinea', iso: 'GN' },
	{ code: '+245', name: 'Guinea-Bissau', iso: 'GW' },
	{ code: '+592', name: 'Guyana', iso: 'GY' },
	{ code: '+509', name: 'Haiti', iso: 'HT' },
	{ code: '+504', name: 'Honduras', iso: 'HN' },
	{ code: '+852', name: 'Hong Kong', iso: 'HK' },
	{ code: '+36', name: 'Hungary', iso: 'HU' },
	{ code: '+354', name: 'Iceland', iso: 'IS' },
	{ code: '+91', name: 'India', iso: 'IN' },
	{ code: '+62', name: 'Indonesia', iso: 'ID' },
	{ code: '+98', name: 'Iran', iso: 'IR' },
	{ code: '+964', name: 'Iraq', iso: 'IQ' },
	{ code: '+353', name: 'Ireland', iso: 'IE' },
	{ code: '+972', name: 'Israel', iso: 'IL' },
	{ code: '+39', name: 'Italy', iso: 'IT' },
	{ code: '+876', name: 'Jamaica', iso: 'JM' },
	{ code: '+81', name: 'Japan', iso: 'JP' },
	{ code: '+44', name: 'Jersey', iso: 'JE' },
	{ code: '+44', name: 'Guernsey', iso: 'GG' },
	{ code: '+962', name: 'Jordan', iso: 'JO' },
	{ code: '+254', name: 'Kenya', iso: 'KE' },
	{ code: '+686', name: 'Kiribati', iso: 'KI' },
	{ code: '+965', name: 'Kuwait', iso: 'KW' },
	{ code: '+996', name: 'Kyrgyzstan', iso: 'KG' },
	{ code: '+856', name: 'Laos', iso: 'LA' },
	{ code: '+371', name: 'Latvia', iso: 'LV' },
	{ code: '+961', name: 'Lebanon', iso: 'LB' },
	{ code: '+266', name: 'Lesotho', iso: 'LS' },
	{ code: '+231', name: 'Liberia', iso: 'LR' },
	{ code: '+218', name: 'Libya', iso: 'LY' },
	{ code: '+423', name: 'Liechtenstein', iso: 'LI' },
	{ code: '+370', name: 'Lithuania', iso: 'LT' },
	{ code: '+352', name: 'Luxembourg', iso: 'LU' },
	{ code: '+853', name: 'Macau', iso: 'MO' },
	{ code: '+261', name: 'Madagascar', iso: 'MG' },
	{ code: '+265', name: 'Malawi', iso: 'MW' },
	{ code: '+60', name: 'Malaysia', iso: 'MY' },
	{ code: '+960', name: 'Maldives', iso: 'MV' },
	{ code: '+223', name: 'Mali', iso: 'ML' },
	{ code: '+356', name: 'Malta', iso: 'MT' },
	{ code: '+222', name: 'Mauritania', iso: 'MR' },
	{ code: '+230', name: 'Mauritius', iso: 'MU' },
	{ code: '+52', name: 'Mexico', iso: 'MX' },
	{ code: '+691', name: 'Micronesia', iso: 'FM' },
	{ code: '+373', name: 'Moldova', iso: 'MD' },
	{ code: '+377', name: 'Monaco', iso: 'MC' },
	{ code: '+976', name: 'Mongolia', iso: 'MN' },
	{ code: '+382', name: 'Montenegro', iso: 'ME' },
	{ code: '+664', name: 'Montserrat', iso: 'MS' },
	{ code: '+212', name: 'Morocco', iso: 'MA' },
	{ code: '+258', name: 'Mozambique', iso: 'MZ' },
	{ code: '+95', name: 'Myanmar / Burma', iso: 'MM' },
	{ code: '+264', name: 'Namibia', iso: 'NA' },
	{ code: '+674', name: 'Nauru', iso: 'NR' },
	{ code: '+977', name: 'Nepal', iso: 'NP' },
	{ code: '+31', name: 'Netherlands', iso: 'NL' },
	{ code: '+64', name: 'New Zealand', iso: 'NZ' },
	{ code: '+505', name: 'Nicaragua', iso: 'NI' },
	{ code: '+227', name: 'Niger', iso: 'NE' },
	{ code: '+234', name: 'Nigeria', iso: 'NG' },
	{ code: '+850', name: 'North Korea', iso: 'KP' },
	{ code: '+389', name: 'North Macedonia', iso: 'MK' },
	{ code: '+47', name: 'Norway', iso: 'NO' },
	{ code: '+968', name: 'Oman', iso: 'OM' },
	{ code: '+92', name: 'Pakistan', iso: 'PK' },
	{ code: '+507', name: 'Panama', iso: 'PA' },
	{ code: '+675', name: 'Papua New Guinea', iso: 'PG' },
	{ code: '+595', name: 'Paraguay', iso: 'PY' },
	{ code: '+51', name: 'Peru', iso: 'PE' },
	{ code: '+63', name: 'Philippines', iso: 'PH' },
	{ code: '+48', name: 'Poland', iso: 'PL' },
	{ code: '+351', name: 'Portugal', iso: 'PT' },
	{ code: '+974', name: 'Qatar', iso: 'QA' },
	{ code: '+40', name: 'Romania', iso: 'RO' },
	{ code: '+7', name: 'Russia', iso: 'RU' },
	{ code: '+250', name: 'Rwanda', iso: 'RW' },
	{ code: '+290', name: 'Saint Helena', iso: 'SH' },
	{ code: '+869', name: 'Saint Kitts and Nevis', iso: 'KN' },
	{ code: '+758', name: 'Saint Lucia', iso: 'LC' },
	{ code: '+784', name: 'Saint Vincent and the Grenadines', iso: 'VC' },
	{ code: '+685', name: 'Samoa', iso: 'WS' },
	{ code: '+378', name: 'San Marino', iso: 'SM' },
	{ code: '+239', name: 'Sao Tome and Principe', iso: 'ST' },
	{ code: '+966', name: 'Saudi Arabia', iso: 'SA' },
	{ code: '+221', name: 'Senegal', iso: 'SN' },
	{ code: '+381', name: 'Serbia', iso: 'RS' },
	{ code: '+248', name: 'Seychelles', iso: 'SC' },
	{ code: '+232', name: 'Sierra Leone', iso: 'SL' },
	{ code: '+65', name: 'Singapore', iso: 'SG' },
	{ code: '+421', name: 'Slovakia', iso: 'SK' },
	{ code: '+677', name: 'Solomon Islands', iso: 'SB' },
	{ code: '+252', name: 'Somalia', iso: 'SO' },
	{ code: '+27', name: 'South Africa', iso: 'ZA' },
	{ code: '+82', name: 'South Korea', iso: 'KR' },
	{ code: '+34', name: 'Spain', iso: 'ES' },
	{ code: '+94', name: 'Sri Lanka', iso: 'LK' },
	{ code: '+249', name: 'Sudan', iso: 'SD' },
	{ code: '+597', name: 'Suriname', iso: 'SR' },
	{ code: '+46', name: 'Sweden', iso: 'SE' },
	{ code: '+41', name: 'Switzerland', iso: 'CH' },
	{ code: '+963', name: 'Syria', iso: 'SY' },
	{ code: '+886', name: 'Taiwan', iso: 'TW' },
	{ code: '+255', name: 'Tanzania', iso: 'TZ' },
	{ code: '+66', name: 'Thailand', iso: 'TH' },
	{ code: '+228', name: 'Togo', iso: 'TG' },
	{ code: '+676', name: 'Tonga', iso: 'TO' },
	{ code: '+868', name: 'Trinidad and Tobago', iso: 'TT' },
	{ code: '+216', name: 'Tunisia', iso: 'TN' },
	{ code: '+90', name: 'Turkey', iso: 'TR' },
	{ code: '+993', name: 'Turkmenistan', iso: 'TM' },
	{ code: '+256', name: 'Uganda', iso: 'UG' },
	{ code: '+380', name: 'Ukraine', iso: 'UA' },
	{ code: '+971', name: 'United Arab Emirates', iso: 'AE' },
	{ code: '+44', name: 'United Kingdom', iso: 'GB' },
	{ code: '+1', name: 'United States', iso: 'US' },
	{ code: '+1', name: 'Canada', iso: 'CA' },
	{ code: '+598', name: 'Uruguay', iso: 'UY' },
	{ code: '+998', name: 'Uzbekistan', iso: 'UZ' },
	{ code: '+678', name: 'Vanuatu', iso: 'VU' },
	{ code: '+58', name: 'Venezuela', iso: 'VE' },
	{ code: '+84', name: 'Vietnam', iso: 'VN' },
	{ code: '+967', name: 'Yemen', iso: 'YE' },
	{ code: '+260', name: 'Zambia', iso: 'ZM' },
	{ code: '+263', name: 'Zimbabwe', iso: 'ZW' },
];

// ---------------------------------------------------------------------------
// Helper: return an <img> flag for a given ISO-2 code.
// Uses flagcdn.com — works on all OS including Windows (emoji flags
// do NOT render on Windows, so we use real images instead).
// ---------------------------------------------------------------------------
function getFlagImg(iso) {
	if (!iso || typeof iso !== 'string' || iso.length !== 2) return '';
	const code = iso.toLowerCase();
	return `<img src="https://flagcdn.com/20x15/${code}.png"
               srcset="https://flagcdn.com/40x30/${code}.png 2x"
               width="20" height="15"
               alt="${iso}"
               loading="lazy"
               onerror="this.style.display='none'"
               style="border-radius:2px;object-fit:cover;flex-shrink:0;display:inline-block;">`;
}

// ---------------------------------------------------------------------------
// Build the legacy CODE_OPTIONS string (for any code that still needs it)
// ---------------------------------------------------------------------------
export const CODE_OPTIONS =
	"<option value='' disabled='' selected='selected'>Code *</option>" +
	DIAL_CODE_DATA.map(
		(c) => `<option value='${c.code}'>${c.code} (${c.name})</option>`,
	).join('');

// ---------------------------------------------------------------------------
// Country name options (unchanged)
// ---------------------------------------------------------------------------
export const COUNTRY_OPTIONS =
	"<option value='none' disabled='' selected='selected'>None</option><option value='Afghanistan'>Afghanistan</option><option value='Albania'>Albania</option><option value='Algeria'>Algeria</option><option value='Andorra'>Andorra</option><option value='Angola'>Angola</option><option value='Antigua and Barbuda'>Antigua and Barbuda</option><option value='Argentina'>Argentina</option><option value='Armenia'>Armenia</option><option value='Australia'>Australia</option><option value='Austria'>Austria</option><option value='Azerbaijan'>Azerbaijan</option><option value='Bahamas'>Bahamas</option><option value='Bahrain'>Bahrain</option><option value='Bangladesh'>Bangladesh</option><option value='Barbados'>Barbados</option><option value='Belarus'>Belarus</option><option value='Belgium'>Belgium</option><option value='Belize'>Belize</option><option value='Benin'>Benin</option><option value='Bhutan'>Bhutan</option><option value='Bolivia'>Bolivia</option><option value='Bosnia and Herzegovina'>Bosnia and Herzegovina</option><option value='Botswana'>Botswana</option><option value='Brazil'>Brazil</option><option value='Brunei'>Brunei</option><option value='Bulgaria'>Bulgaria</option><option value='Burkina Faso'>Burkina Faso</option><option value='Burundi'>Burundi</option><option value='Cabo Verde'>Cabo Verde</option><option value='Cambodia'>Cambodia</option><option value='Cameroon'>Cameroon</option><option value='Canada'>Canada</option><option value='Central African Republic'>Central African Republic</option><option value='Chad'>Chad</option><option value='Chile'>Chile</option><option value='China'>China</option><option value='Colombia'>Colombia</option><option value='Comoros'>Comoros</option><option value='Congo, Democratic Republic of the'>Congo, Democratic Republic of the</option><option value='Congo, Republic of the'>Congo, Republic of the</option><option value='Costa Rica'>Costa Rica</option><option value='Cote d&apos;Ivoire'>Cote d&apos;Ivoire</option><option value='Croatia'>Croatia</option><option value='Cuba'>Cuba</option><option value='Cyprus'>Cyprus</option><option value='Czech Republic'>Czech Republic</option><option value='Denmark'>Denmark</option><option value='Djibouti'>Djibouti</option><option value='Dominica'>Dominica</option><option value='Dominican Republic'>Dominican Republic</option><option value='Ecuador'>Ecuador</option><option value='Egypt'>Egypt</option><option value='El Salvador'>El Salvador</option><option value='Equatorial Guinea'>Equatorial Guinea</option><option value='Eritrea'>Eritrea</option><option value='Estonia'>Estonia</option><option value='Eswatini'>Eswatini</option><option value='Ethiopia'>Ethiopia</option><option value='Fiji'>Fiji</option><option value='Finland'>Finland</option><option value='France'>France</option><option value='Gabon'>Gabon</option><option value='Gambia'>Gambia</option><option value='Georgia'>Georgia</option><option value='Germany'>Germany</option><option value='Ghana'>Ghana</option><option value='Greece'>Greece</option><option value='Grenada'>Grenada</option><option value='Guatemala'>Guatemala</option><option value='Guinea'>Guinea</option><option value='Guinea-Bissau'>Guinea-Bissau</option><option value='Guyana'>Guyana</option><option value='Haiti'>Haiti</option><option value='Honduras'>Honduras</option><option value='Hungary'>Hungary</option><option value='Iceland'>Iceland</option><option value='India'>India</option><option value='Indonesia'>Indonesia</option><option value='Iran'>Iran</option><option value='Iraq'>Iraq</option><option value='Ireland'>Ireland</option><option value='Israel'>Israel</option><option value='Italy'>Italy</option><option value='Jamaica'>Jamaica</option><option value='Japan'>Japan</option><option value='Jordan'>Jordan</option><option value='Kazakhstan'>Kazakhstan</option><option value='Kenya'>Kenya</option><option value='Kiribati'>Kiribati</option><option value='Kosovo'>Kosovo</option><option value='Kuwait'>Kuwait</option><option value='Kyrgyzstan'>Kyrgyzstan</option><option value='Laos'>Laos</option><option value='Latvia'>Latvia</option><option value='Lebanon'>Lebanon</option><option value='Lesotho'>Lesotho</option><option value='Liberia'>Liberia</option><option value='Libya'>Libya</option><option value='Liechtenstein'>Liechtenstein</option><option value='Lithuania'>Lithuania</option><option value='Luxembourg'>Luxembourg</option><option value='Madagascar'>Madagascar</option><option value='Malawi'>Malawi</option><option value='Malaysia'>Malaysia</option><option value='Maldives'>Maldives</option><option value='Mali'>Mali</option><option value='Malta'>Malta</option><option value='Marshall Islands'>Marshall Islands</option><option value='Mauritania'>Mauritania</option><option value='Mauritius'>Mauritius</option><option value='Mexico'>Mexico</option><option value='Micronesia'>Micronesia</option><option value='Moldova'>Moldova</option><option value='Monaco'>Monaco</option><option value='Mongolia'>Mongolia</option><option value='Montenegro'>Montenegro</option><option value='Morocco'>Morocco</option><option value='Mozambique'>Mozambique</option><option value='Myanmar (Burma)'>Myanmar (Burma)</option><option value='Namibia'>Namibia</option><option value='Nauru'>Nauru</option><option value='Nepal'>Nepal</option><option value='Netherlands'>Netherlands</option><option value='New Zealand'>New Zealand</option><option value='Nicaragua'>Nicaragua</option><option value='Niger'>Niger</option><option value='Nigeria'>Nigeria</option><option value='North Korea'>North Korea</option><option value='North Macedonia'>North Macedonia</option><option value='Norway'>Norway</option><option value='Oman'>Oman</option><option value='Pakistan'>Pakistan</option><option value='Palau'>Palau</option><option value='Palestine'>Palestine</option><option value='Panama'>Panama</option><option value='Papua New Guinea'>Papua New Guinea</option><option value='Paraguay'>Paraguay</option><option value='Peru'>Peru</option><option value='Philippines'>Philippines</option><option value='Poland'>Poland</option><option value='Portugal'>Portugal</option><option value='Qatar'>Qatar</option><option value='Romania'>Romania</option><option value='Russia'>Russia</option><option value='Rwanda'>Rwanda</option><option value='Saint Kitts and Nevis'>Saint Kitts and Nevis</option><option value='Saint Lucia'>Saint Lucia</option><option value='Saint Vincent and the Grenadines'>Saint Vincent and the Grenadines</option><option value='Samoa'>Samoa</option><option value='San Marino'>San Marino</option><option value='Sao Tome and Principe'>Sao Tome and Principe</option><option value='Saudi Arabia'>Saudi Arabia</option><option value='Senegal'>Senegal</option><option value='Serbia'>Serbia</option><option value='Seychelles'>Seychelles</option><option value='Sierra Leone'>Sierra Leone</option><option value='Singapore'>Singapore</option><option value='Slovakia'>Slovakia</option><option value='Slovenia'>Slovenia</option><option value='Solomon Islands'>Solomon Islands</option><option value='Somalia'>Somalia</option><option value='South Africa'>South Africa</option><option value='South Korea'>South Korea</option><option value='South Sudan'>South Sudan</option><option value='Spain'>Spain</option><option value='Sri Lanka'>Sri Lanka</option><option value='Sudan'>Sudan</option><option value='Suriname'>Suriname</option><option value='Sweden'>Sweden</option><option value='Switzerland'>Switzerland</option><option value='Syria'>Syria</option><option value='Taiwan'>Taiwan</option><option value='Tajikistan'>Tajikistan</option><option value='Tanzania'>Tanzania</option><option value='Thailand'>Thailand</option><option value='Timor-Leste'>Timor-Leste</option><option value='Togo'>Togo</option><option value='Tonga'>Tonga</option><option value='Trinidad and Tobago'>Trinidad and Tobago</option><option value='Tunisia'>Tunisia</option><option value='Turkey'>Turkey</option><option value='Turkmenistan'>Turkmenistan</option><option value='Tuvalu'>Tuvalu</option><option value='Uganda'>Uganda</option><option value='Ukraine'>Ukraine</option><option value='United Arab Emirates'>United Arab Emirates</option><option value='United Kingdom'>United Kingdom</option><option value='United States of America'>United States of America</option><option value='Uruguay'>Uruguay</option><option value='Uzbekistan'>Uzbekistan</option><option value='Vanuatu'>Vanuatu</option><option value='Vatican City (Holy See)'>Vatican City (Holy See)</option><option value='Venezuela'>Venezuela</option><option value='Vietnam'>Vietnam</option><option value='Yemen'>Yemen</option><option value='Zambia'>Zambia</option><option value='Zimbabwe'>Zimbabwe</option>";

// ---------------------------------------------------------------------------
// Cached IP Auto-Detection
// Fetches once per page session and reuses across all form instances
// ---------------------------------------------------------------------------
let cachedIpData = null;
let cachedIpPromise = null;

function fetchUserCountry() {
	if (cachedIpData) {
		return Promise.resolve(cachedIpData);
	}
	if (!cachedIpPromise) {
		cachedIpPromise = fetch('https://ipapi.co/json/')
			.then((res) => {
				if (!res.ok) throw new Error('IP API network error');
				return res.json();
			})
			.then((data) => {
				cachedIpData = data;
				return data;
			})
			.catch(() => null);
	}
	return cachedIpPromise;
}

// ---------------------------------------------------------------------------
// Build and wire a custom flag+code dropdown for a given <select> element
// ---------------------------------------------------------------------------
export function initCustomPhoneCodeDropdown(selectEl) {
	if (!selectEl) return;

	// Idempotency check: don't double-initialize
	if (
		selectEl.dataset.fcdInitialized === 'true' ||
		selectEl.closest('.flag-code-dropdown')
	) {
		const existingWrapper = selectEl.closest('.flag-code-dropdown');
		if (
			existingWrapper &&
			typeof existingWrapper._ensureSelected === 'function'
		) {
			existingWrapper._ensureSelected();
		}
		return existingWrapper;
	}
	selectEl.dataset.fcdInitialized = 'true';

	// Track default and current selected country (default: India +91)
	let defaultCountry = { code: '+91', iso: 'IN', name: 'India' };

	// If selectEl already has a selected dial code, honor it
	if (selectEl.value && selectEl.value !== 'none' && selectEl.value !== '') {
		const matched = DIAL_CODE_DATA.find((c) => c.code === selectEl.value);
		if (matched) {
			defaultCountry = {
				code: matched.code,
				iso: matched.iso,
				name: matched.name,
			};
		}
	}

	let currentCountry = { ...defaultCountry };

	// Populate the hidden <select> with options if needed (for form submission)
	if (
		selectEl.children.length <= 1 ||
		!selectEl.querySelector('option[value="+91"]')
	) {
		selectEl.innerHTML = CODE_OPTIONS;
	}

	// Ensure initial option exists and is selected
	let initialOpt = selectEl.querySelector(
		`option[value="${currentCountry.code}"]`,
	);
	if (!initialOpt) {
		initialOpt = document.createElement('option');
		initialOpt.value = currentCountry.code;
		initialOpt.textContent = `${currentCountry.code} ${currentCountry.name}`;
		selectEl.appendChild(initialOpt);
	}
	selectEl.value = currentCountry.code;

	// Hide the native select visually but keep it in DOM for form validation & submission
	selectEl.style.cssText =
		'position:absolute;opacity:0;width:0;height:0;pointer-events:none;';

	// ── Build wrapper ─────────────────────────────────────────────────────────
	const wrapper = document.createElement('div');
	wrapper.className = 'flag-code-dropdown';
	selectEl.parentNode.insertBefore(wrapper, selectEl);
	wrapper.appendChild(selectEl); // move select inside wrapper

	// Hide any sibling static SVG arrows or placeholder labels inside the same container
	const parent = wrapper.parentElement;
	if (parent) {
		parent
			.querySelectorAll(':scope > svg.drop-down, :scope > svg')
			.forEach((svg) => {
				svg.style.display = 'none';
			});
		parent
			.querySelectorAll(':scope > label.disabledLabels')
			.forEach((lbl) => {
				lbl.style.display = 'none';
			});
	}

	// ── Trigger button ────────────────────────────────────────────────────────
	const trigger = document.createElement('button');
	trigger.type = 'button';
	trigger.className = 'flag-code-trigger';
	trigger.setAttribute('aria-haspopup', 'listbox');
	trigger.setAttribute('aria-expanded', 'false');
	trigger.innerHTML = `
    <span class="fcd-flag" style="display:flex;align-items:center;">${getFlagImg(
		currentCountry.iso,
	)}</span>
    <span class="fcd-code">${currentCountry.code}</span>
    <span class="fcd-arrow">▼</span>
  `;
	wrapper.appendChild(trigger);

	// ── List panel ────────────────────────────────────────────────────────────
	const listPanel = document.createElement('div');
	listPanel.className = 'flag-code-list';
	listPanel.style.display = 'none'; // explicitly hidden initially
	listPanel.setAttribute('role', 'listbox');

	// Search input
	const searchWrap = document.createElement('div');
	searchWrap.className = 'fcd-search-wrap';
	const searchInput = document.createElement('input');
	searchInput.type = 'text';
	searchInput.className = 'fcd-search';
	searchInput.placeholder = 'Search country or code…';
	searchInput.setAttribute('aria-label', 'Search country code');
	searchInput.autocomplete = 'off';
	searchWrap.appendChild(searchInput);
	listPanel.appendChild(searchWrap);

	wrapper.appendChild(listPanel);

	// ── Render options ────────────────────────────────────────────────────────
	function renderOptions(filter) {
		// Remove old items (keep search wrap)
		while (listPanel.children.length > 1) {
			listPanel.removeChild(listPanel.lastChild);
		}

		const raw = (filter || '').trim().toLowerCase();
		const cleanNum = raw.replace(/[+()\s-]/g, '');

		const filtered = raw
			? DIAL_CODE_DATA.filter((c) => {
					const cName = c.name.toLowerCase();
					const cCodeDigits = c.code.replace(/[+()\s-]/g, '');
					const cCodeFull = c.code.toLowerCase();

					// Typing digits like 91, 43, 1
					if (
						cleanNum &&
						(cCodeDigits.startsWith(cleanNum) ||
							cCodeDigits === cleanNum)
					) {
						return true;
					}
					// Typing with plus like +91, +43
					if (raw.startsWith('+') && cCodeFull.startsWith(raw)) {
						return true;
					}
					// Typing country name like "india", "austria", "states"
					if (cName.includes(raw)) {
						return true;
					}
					// Typing ISO code like "in", "us"
					if (c.iso && c.iso.toLowerCase() === raw) {
						return true;
					}
					return false;
				})
			: DIAL_CODE_DATA;

		if (filtered.length === 0) {
			const empty = document.createElement('div');
			empty.className = 'fcd-no-results';
			empty.textContent = 'No results found';
			listPanel.appendChild(empty);
			return;
		}

		filtered.forEach((c) => {
			const flagHtml = getFlagImg(c.iso);
			const item = document.createElement('div');
			item.className = 'fcd-option';
			item.setAttribute('role', 'option');
			item.dataset.value = c.code;
			const selectedIso =
				selectEl.dataset.selectedIso || currentCountry.iso;
			if (c.iso === selectedIso) item.classList.add('fcd-selected');
			item.innerHTML = `
        <span class="fcd-opt-flag">${flagHtml}</span>
        <span class="fcd-opt-code">${c.code}</span>
        <span class="fcd-opt-name">${c.name}</span>
      `;
			let selected = false;
			const handleSelect = (e) => {
				if (selected) return;
				selected = true;
				e.preventDefault();
				e.stopPropagation();
				currentCountry = { code: c.code, iso: c.iso, name: c.name };
				selectValue(c.code, flagHtml, c.iso);
				closeList();
			};
			item.addEventListener('mousedown', handleSelect);
			item.addEventListener('click', handleSelect);
			listPanel.appendChild(item);
		});
	}

	// ── Update display after selection ────────────────────────────────────────
	function selectValue(code, flagHtml, iso) {
		if (!code) return;

		// Ensure option exists in selectEl
		let opt = selectEl.querySelector(`option[value="${code}"]`);
		if (!opt) {
			opt = document.createElement('option');
			opt.value = code;
			opt.textContent = `${code} ${iso || ''}`;
			selectEl.appendChild(opt);
		}

		selectEl.value = code;
		if (iso) selectEl.dataset.selectedIso = iso;

		const flagSpan = trigger.querySelector('.fcd-flag');
		if (flagSpan) {
			flagSpan.innerHTML = flagHtml || (iso ? getFlagImg(iso) : '🌐');
		}

		const codeSpan = trigger.querySelector('.fcd-code');
		if (codeSpan) {
			codeSpan.textContent = code;
		}

		trigger.setAttribute('aria-expanded', 'false');
		wrapper.classList.remove('fcd-open');
		listPanel.style.display = 'none';

		// Dispatch change & input events so JustValidate and other listeners know it has a value
		selectEl.dispatchEvent(new Event('change', { bubbles: true }));
		selectEl.dispatchEvent(new Event('input', { bubbles: true }));
	}

	// ── Open / close ──────────────────────────────────────────────────────────
	function openList() {
		wrapper.classList.add('fcd-open');
		listPanel.style.display = 'block'; // force visible
		trigger.setAttribute('aria-expanded', 'true');
		searchInput.value = '';
		renderOptions('');
		// Scroll selected item into view and focus search input
		setTimeout(() => {
			const selected = listPanel.querySelector('.fcd-selected');
			if (selected) selected.scrollIntoView({ block: 'nearest' });
			searchInput.focus();
		}, 10);
	}

	function closeList() {
		wrapper.classList.remove('fcd-open');
		listPanel.style.display = 'none'; // force hidden
		trigger.setAttribute('aria-expanded', 'false');
	}

	trigger.addEventListener('click', (e) => {
		e.stopPropagation();
		e.preventDefault();
		wrapper.classList.contains('fcd-open') ? closeList() : openList();
	});

	listPanel.addEventListener('click', (e) => {
		e.stopPropagation();
	});

	// Close when clicking outside
	document.addEventListener('click', (e) => {
		if (!wrapper.contains(e.target)) closeList();
	});

	// Search filtering
	searchInput.addEventListener('input', () => {
		renderOptions(searchInput.value);
	});

	// Keyboard nav inside search
	searchInput.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			closeList();
			trigger.focus();
		}
		if (e.key === 'Enter') {
			e.preventDefault();
			const first = listPanel.querySelector('.fcd-option');
			if (first) {
				first.dispatchEvent(new MouseEvent('mousedown'));
			}
		}
	});

	// Form reset listener - always restore current/default country code
	if (selectEl.form) {
		selectEl.form.addEventListener('reset', () => {
			setTimeout(() => {
				selectValue(
					currentCountry.code,
					getFlagImg(currentCountry.iso),
					currentCountry.iso,
				);
				wrapper.classList.remove('fcd-open');
				listPanel.style.display = 'none';
				trigger.setAttribute('aria-expanded', 'false');
			}, 0);
		});
	}

	// Observer to protect selectEl value against external delayed script overwrites (e.g. country.js)
	try {
		const observer = new MutationObserver(() => {
			if (
				!selectEl.value ||
				selectEl.value === 'none' ||
				selectEl.value === ''
			) {
				selectValue(
					currentCountry.code,
					getFlagImg(currentCountry.iso),
					currentCountry.iso,
				);
			}
		});
		observer.observe(selectEl, { childList: true });
	} catch (err) {
		// Ignore in older environments
	}

	// Initial render of options
	renderOptions('');

	// ── Expose method to set value programmatically (for IP auto-detect) ────
	wrapper._setFlagCode = function (code, isoHint) {
		let entry = null;
		if (isoHint) {
			entry = DIAL_CODE_DATA.find((c) => c.iso === isoHint.toUpperCase());
		}
		if (!entry && code) {
			entry = DIAL_CODE_DATA.find((c) => c.code === code);
		}
		if (entry) {
			defaultCountry = {
				code: entry.code,
				iso: entry.iso,
				name: entry.name,
			};
			currentCountry = { ...defaultCountry };
			const flagHtml = getFlagImg(entry.iso);
			selectValue(entry.code, flagHtml, entry.iso);
		}
	};

	// ── Expose method to ensure country is selected on modal reopen ───────────
	wrapper._ensureSelected = function () {
		wrapper.classList.remove('fcd-open');
		listPanel.style.display = 'none';
		trigger.setAttribute('aria-expanded', 'false');
		if (
			!selectEl.value ||
			selectEl.value === 'none' ||
			selectEl.value === ''
		) {
			selectValue(
				currentCountry.code,
				getFlagImg(currentCountry.iso),
				currentCountry.iso,
			);
		}
	};

	// ── Auto-detect country via IP (Cached) ─────────────────────────────────
	fetchUserCountry()
		.then((data) => {
			if (data && data.country_calling_code && wrapper._setFlagCode) {
				wrapper._setFlagCode(
					data.country_calling_code,
					data.country_code,
				);
			}
		})
		.catch(() => {
			// Gracefully ignore network or adblocker restrictions; India +91 is already set
		});
}

// ---------------------------------------------------------------------------
// Initialize all phone code dropdowns on the page
// Matches all phone code select elements across all forms in the theme
// ---------------------------------------------------------------------------
export function initAllPhoneCodeDropdowns() {
	if (typeof document === 'undefined') return;
	const selector =
		'select.country-phone-code, select[name="phonecode"], select[name="country-phone-code"], select#country-phone-code, select#phonecode';
	const selects = document.querySelectorAll(selector);
	selects.forEach((selectEl) => {
		initCustomPhoneCodeDropdown(selectEl);
	});
}

// ---------------------------------------------------------------------------
// Dedicated initialization for Cyntexa #needform (alias for backwards-compat)
// ---------------------------------------------------------------------------
export function initNeedFormCountryDropdown() {
	initAllPhoneCodeDropdowns();
}

// Auto-run on DOM ready
if (typeof document !== 'undefined') {
	if (document.readyState === 'loading') {
		document.addEventListener(
			'DOMContentLoaded',
			initAllPhoneCodeDropdowns,
		);
	} else {
		initAllPhoneCodeDropdowns();
	}
}

// Expose globally so external or inline scripts can re-trigger when needed
if (typeof window !== 'undefined') {
	window.initAllPhoneCodeDropdowns = initAllPhoneCodeDropdowns;
	window.initCustomPhoneCodeDropdown = initCustomPhoneCodeDropdown;
}
